import { createTimeline } from 'animejs';

export default function Scan_Animation(animation_el) {
	const line_el = animation_el.getElementsByClassName(`scan-line`);
	if (!line_el) {
		return;
	}

	const result_els = animation_el.getElementsByClassName(`scan-result`);

	const tl = createTimeline({
		autoplay: false,
		loop: true,
		loopDelay: 1800,
	});

	tl.add(line_el, {
		duration: 0,
		opacity: 1,
	});

	tl.add(line_el, {
		height: `100%`,
		duration: 800,
		easing: `easeInOutSine`,
	});

	for (let i = 0; i < result_els.length; i++) {
		const result_el = result_els[i];

		tl.add(result_el, {
			translateY: -16,
			duration: 0,
		});

		tl.add(result_el, {
			opacity: 1,
			translateY: 0,
			duration: 600,
		});
	}

	return {
		play: () => {
			tl.play();
		},
		pause: () => {
			tl.pause();
		},
	};
}
